export const DefaultBlankDateText = "-";
export const DefaultBlankCurrencyText = "-";
export const DefaultBlankStringText = "-";
